import { atomWithQuery } from 'jotai-tanstack-query';
import { getAvailableTrialSubject } from '@services/GeniebookAPI/SubscriptionService.service';
import { SLOW_DATA_STALE_TIME_IN_SECONDS } from '@utils/constants/global.constants';
import { atom } from 'jotai';
import userService from '@services/GeniebookAPI/UserServices.services';

// react query
export const availableSubjectForTrialQueryAtom = atomWithQuery(() => {
  return {
    queryKey: ['available-trial-subject'],
    queryFn: () => getAvailableTrialSubject(),
    staleTime: SLOW_DATA_STALE_TIME_IN_SECONDS * 1000,
  };
});

export const userDetailQueryAtom = atomWithQuery(() => {
  return {
    queryKey: ['userDetails'],
    queryFn: () => userService.userDetail(),
    staleTime: SLOW_DATA_STALE_TIME_IN_SECONDS * 1000,
  };
});

export const subjectSubscriptionsQueryAtom = atomWithQuery(() => {
  return {
    queryKey: ['subscriptionData'],
    queryFn: () => userService.getSubjectSubscription(),
    staleTime: SLOW_DATA_STALE_TIME_IN_SECONDS * 1000,
  };
});

// derived atom
export const haveSubjectForTrialAtom = atom(get => {
  const queryData = get(availableSubjectForTrialQueryAtom);

  return !!(
    queryData.data?.data?.data?.available_trial_subjects &&
    queryData.data.data.data.available_trial_subjects.length > 0
  );
});

export const userDetailAtom = atom(get => {
  const queryData = get(userDetailQueryAtom);
  return queryData.data?.data;
});

export const subjectSubscriptionsAtom = atom(get => {
  const queryData = get(subjectSubscriptionsQueryAtom);
  return queryData.data?.data?.data;
});
